import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "web-layout__nav__wrapper flex justify-between items-start sm:items-center" }
const _hoisted_2 = { class: "flex gap-3 items-center web-layout__nav__left justify-between" }
const _hoisted_3 = { class: "flex items-center gap-3 web-layout__nav--logo" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "bg-slate-200 animate-pulse rounded-lg mr-4",
  style: {"height":"4rem","width":"10rem"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"bg-red-500 w-2 h-2 rounded-full absolute top-0 left-0\"></div><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"><path d=\"M11.68 14.62L14.24 12.06L11.68 9.5\" stroke=\"#292f31\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M4 12.0601H14.17\" stroke=\"#292f31\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M12 4C16.42 4 20 7 20 12C20 17 16.42 20 12 20\" stroke=\"#292f31\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg>", 2)
const _hoisted_9 = [
  _hoisted_7
]
const _hoisted_10 = {
  key: 1,
  class: "flex flex-col items-center web-layout__nav__left__profile hidden"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.1601 10.87C12.0601 10.86 11.9401 10.86 11.8301 10.87C9.45006 10.79 7.56006 8.84 7.56006 6.44C7.56006 3.99 9.54006 2 12.0001 2C14.4501 2 16.4401 3.99 16.4401 6.44C16.4301 8.84 14.5401 10.79 12.1601 10.87Z",
    stroke: "#292f31",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7.15997 14.56C4.73997 16.18 4.73997 18.82 7.15997 20.43C9.90997 22.27 14.42 22.27 17.17 20.43C19.59 18.81 19.59 16.17 17.17 14.56C14.43 12.73 9.91997 12.73 7.15997 14.56Z",
    stroke: "#292f31",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_12 = { class: "text-sm" }
const _hoisted_13 = { class: "w-full" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  class: "search-icon"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0.0247006 7.87823C0.162935 9.46532 0.887052 10.9532 2.06688 12.0735C3.24671 13.1938 4.80475 13.8732 6.46033 13.9891C8.11592 14.1051 9.76012 13.6501 11.0972 12.7061L14.2375 15.7092C14.4312 15.8952 14.6938 15.9996 14.9677 15.9996C15.2415 15.9996 15.5043 15.8953 15.6978 15.7093C15.8915 15.5235 16.0002 15.2714 16 15.0085C16.0002 14.7458 15.8915 14.4937 15.698 14.3078L12.5681 11.2947C13.9283 9.5308 14.2998 7.23853 13.5616 5.1613C12.8236 3.08439 11.0702 1.48725 8.86994 0.888013C6.66989 0.288729 4.30337 0.763496 2.53789 2.15874C0.772543 3.55382 -0.16685 5.69131 0.0244658 7.87791L0.0247006 7.87823ZM6.96867 2.62946C8.26895 2.62946 9.51591 3.12511 10.4353 4.00726C11.3547 4.88941 11.8713 6.08607 11.8713 7.33363C11.8713 8.58119 11.3547 9.77768 10.4353 10.6598C9.51591 11.542 8.2689 12.0376 6.96867 12.0376C5.66844 12.0376 4.42124 11.542 3.50184 10.6598C2.58245 9.77768 2.06587 8.58119 2.06587 7.33363C2.06587 6.08607 2.58245 4.88941 3.50184 4.00726C4.42124 3.12511 5.66844 2.62946 6.96867 2.62946Z",
    fill: "#676767"
  })
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "28",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    opacity: "0.4",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "#676767"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M13.0599 12.0001L15.3599 9.70011C15.6499 9.41011 15.6499 8.93011 15.3599 8.64011C15.0699 8.35011 14.5899 8.35011 14.2999 8.64011L11.9999 10.9401L9.69986 8.64011C9.40986 8.35011 8.92986 8.35011 8.63986 8.64011C8.34986 8.93011 8.34986 9.41011 8.63986 9.70011L10.9399 12.0001L8.63986 14.3001C8.34986 14.5901 8.34986 15.0701 8.63986 15.3601C8.78986 15.5101 8.97986 15.5801 9.16986 15.5801C9.35986 15.5801 9.54986 15.5101 9.69986 15.3601L11.9999 13.0601L14.2999 15.3601C14.4499 15.5101 14.6399 15.5801 14.8299 15.5801C15.0199 15.5801 15.2099 15.5101 15.3599 15.3601C15.6499 15.0701 15.6499 14.5901 15.3599 14.3001L13.0599 12.0001Z",
    fill: "#292f31"
  })
], -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "py-2 px-2 mt-2 sm:hidden block rounded-xl flex justify-between items-center" }
const _hoisted_18 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z",
  style: {"fill":"currentcolor"}
}, null, -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", {
  class: "",
  style: {"color":"#2D2E2F"}
}, "menu", -1)
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "flex items-center gap-4" }
const _hoisted_24 = /*#__PURE__*/_createStaticVNode("<svg width=\"18\" height=\"18\" viewBox=\"0 0 23 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"bell\"><g clip-path=\"url(#clip0_1568_5365)\"><path d=\"M21.7748 18.1822H20.6303V9.09086C20.6303 6.67982 19.6645 4.36752 17.9454 2.66265C16.2263 0.957784 13.8947 0 11.4635 0C9.03237 0 6.70076 0.957784 4.98166 2.66265C3.26256 4.36752 2.29677 6.67982 2.29677 9.09086V18.1812H1.15229C0.848759 18.1812 0.557656 18.3008 0.343024 18.5136C0.128392 18.7265 0.0078125 19.0152 0.0078125 19.3162C0.0078125 19.6172 0.128392 19.9059 0.343024 20.1188C0.557656 20.3316 0.848759 20.4512 1.15229 20.4512H6.87574C6.87574 21.6567 7.3586 22.8128 8.21811 23.6651C9.07761 24.5175 10.2433 24.9964 11.4589 24.9964C12.6744 24.9964 13.8401 24.5175 14.6996 23.6651C15.5591 22.8128 16.042 21.6567 16.042 20.4512H21.7748C22.0783 20.4512 22.3694 20.3316 22.5841 20.1188C22.7987 19.9059 22.9193 19.6172 22.9193 19.3162C22.9193 19.0152 22.7987 18.7265 22.5841 18.5136C22.3694 18.3008 22.0783 18.1812 21.7748 18.1812V18.1822ZM11.462 22.7274C10.8549 22.7274 10.2727 22.4883 9.84344 22.0625C9.41418 21.6368 9.17303 21.0595 9.17303 20.4574H13.7561C13.7562 20.7562 13.6967 21.0521 13.5811 21.328C13.4656 21.604 13.2962 21.8546 13.0828 22.0655C12.8694 22.2764 12.616 22.4434 12.3374 22.557C12.0587 22.6706 11.7602 22.7285 11.4589 22.7274H11.462ZM18.3372 18.1822H4.58366V9.09086C4.58366 8.19547 4.76149 7.30885 5.107 6.48162C5.45251 5.65439 5.95894 4.90275 6.59736 4.26961C7.23578 3.63648 7.9937 3.13425 8.82784 2.7916C9.66197 2.44895 10.556 2.27259 11.4589 2.27259C12.3617 2.27259 13.2558 2.44895 14.0899 2.7916C14.924 3.13425 15.6819 3.63648 16.3204 4.26961C16.9588 4.90275 17.4652 5.65439 17.8107 6.48162C18.1562 7.30885 18.3341 8.19547 18.3341 9.09086L18.3372 18.1822Z\" fill=\"#292F31\"></path></g><defs><clipPath id=\"clip0_1568_5365\"><rect width=\"22.9167\" height=\"25\" fill=\"white\"></rect></clipPath></defs></svg>", 1)
const _hoisted_25 = {
  key: 0,
  class: "w-4 flex items-center justify-center h-4 bg-red-600 rounded-full absolute top-[-45%] right-[-30%] text-white font-bold text-xs"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96451 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.7473 9.41498 20.7192 6.93661 18.8913 5.10872C17.0634 3.28084 14.585 2.25273 12 2.25ZM11.625 6.75C11.8475 6.75 12.065 6.81598 12.25 6.9396C12.435 7.06321 12.5792 7.23891 12.6644 7.44448C12.7495 7.65005 12.7718 7.87625 12.7284 8.09448C12.685 8.31271 12.5778 8.51316 12.4205 8.6705C12.2632 8.82783 12.0627 8.93498 11.8445 8.97838C11.6263 9.02179 11.4001 8.99951 11.1945 8.91436C10.9889 8.82922 10.8132 8.68502 10.6896 8.50002C10.566 8.31501 10.5 8.0975 10.5 7.875C10.5 7.57663 10.6185 7.29048 10.8295 7.0795C11.0405 6.86853 11.3266 6.75 11.625 6.75ZM12.75 17.25C12.3522 17.25 11.9706 17.092 11.6893 16.8107C11.408 16.5294 11.25 16.1478 11.25 15.75V12C11.0511 12 10.8603 11.921 10.7197 11.7803C10.579 11.6397 10.5 11.4489 10.5 11.25C10.5 11.0511 10.579 10.8603 10.7197 10.7197C10.8603 10.579 11.0511 10.5 11.25 10.5C11.6478 10.5 12.0294 10.658 12.3107 10.9393C12.592 11.2206 12.75 11.6022 12.75 12V15.75C12.9489 15.75 13.1397 15.829 13.2803 15.9697C13.421 16.1103 13.5 16.3011 13.5 16.5C13.5 16.6989 13.421 16.8897 13.2803 17.0303C13.1397 17.171 12.9489 17.25 12.75 17.25Z",
    fill: "#323232"
  })
], -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { class: "web-layout__nav__right gap-4 items-center hidden lg:flex" }
const _hoisted_29 = { class: "" }
const _hoisted_30 = {
  style: {"width":"1.2rem","height":"1.2rem"},
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "#292f31"
}
const _hoisted_31 = {
  class: "relative",
  id: "menu_dropdown"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.1601 10.87C12.0601 10.86 11.9401 10.86 11.8301 10.87C9.45006 10.79 7.56006 8.84 7.56006 6.44C7.56006 3.99 9.54006 2 12.0001 2C14.4501 2 16.4401 3.99 16.4401 6.44C16.4301 8.84 14.5401 10.79 12.1601 10.87Z",
    stroke: "currentColor",
    class: "transition-colors duration-200",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7.15997 14.56C4.73997 16.18 4.73997 18.82 7.15997 20.43C9.90997 22.27 14.42 22.27 17.17 20.43C19.59 18.81 19.59 16.17 17.17 14.56C14.43 12.73 9.91997 12.73 7.15997 14.56Z",
    stroke: "currentColor",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    class: "transition-colors duration-200"
  })
], -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", null, " perfil ", -1)
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = { class: "text-xl font-semibold px-8 py-2" }
const _hoisted_36 = { class: "flex flex-col justify-between items-between h-full py-4" }
const _hoisted_37 = { class: "flex flex-col gap-2" }
const _hoisted_38 = {
  key: 0,
  class: "px-8 py-4 mt-4 flex items-center gap-4 bg-f5"
}
const _hoisted_39 = ["src"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("h6", { class: "pb-2" }, "Instalar app", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 text-xs" }, "Adicione o nosso app a tela principal do seu dispositivo", -1)
const _hoisted_42 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.3rem","height":"1.3rem"}
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("path", {
  d: "M2 12H4V17H20V12H22V17C22 18.11 21.11 19 20 19H4C2.9 19 2 18.11 2 17V12M12 15L17.55 9.54L16.13 8.13L13 11.25V2H11V11.25L7.88 8.13L6.46 9.55L12 15Z",
  style: {"fill":"#fff"}
}, null, -1)
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = { class: "flex gap-4 items-center" }
const _hoisted_46 = {
  style: {"width":"1.2rem","height":"1.2rem"},
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "#292f31"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("h6", null, "Categorias", -1)
const _hoisted_48 = { class: "flex items-center gap-4" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("svg", {
  fill: "none",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "none",
    d: "M8 7H16M9 11H15M6.73 19.7C7.55 18.82 8.8 18.89 9.52 19.85L10.53 21.2C11.34 22.27 12.65 22.27 13.46 21.2L14.47 19.85C15.19 18.89 16.44 18.82 17.26 19.7C19.04 21.6 20.49 20.97 20.49 18.31V7.04C20.5 3.01 19.56 2 15.78 2H8.22C4.44 2 3.5 3.01 3.5 7.04V18.3C3.5 20.97 4.96 21.59 6.73 19.7Z",
    stroke: "currentColor",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    class: "transition-colors duration-200"
  })
], -1)
const _hoisted_50 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center gap-4\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"25\" height=\"24\" viewBox=\"0 0 25 24\" fill=\"none\"><path d=\"M12.0357 2.91003C8.72571 2.91003 6.03571 5.60003 6.03571 8.91003V11.8C6.03571 12.41 5.77571 13.34 5.46571 13.86L4.31571 15.77C3.60571 16.95 4.09571 18.26 5.39571 18.7C9.70571 20.14 14.3557 20.14 18.6657 18.7C19.8757 18.3 20.4057 16.87 19.7457 15.77L18.5957 13.86C18.2957 13.34 18.0357 12.41 18.0357 11.8V8.91003C18.0357 5.61003 15.3357 2.91003 12.0357 2.91003Z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" class=\"transition-colors duration-200\"></path><path d=\"M13.8855 3.19994C13.5755 3.10994 13.2555 3.03994 12.9255 2.99994C11.9655 2.87994 11.0455 2.94994 10.1855 3.19994C10.4755 2.45994 11.1955 1.93994 12.0355 1.93994C12.8755 1.93994 13.5955 2.45994 13.8855 3.19994Z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"transition-colors duration-200\"></path><path d=\"M15.0356 19.0601C15.0356 20.7101 13.6856 22.0601 12.0356 22.0601C11.2156 22.0601 10.4556 21.7201 9.91564 21.1801C9.37564 20.6401 9.03564 19.8801 9.03564 19.0601\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" class=\"transition-colors duration-200\"></path></svg><div><h6>Notificações</h6></div></div>", 1)
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = { class: "flex items-center gap-4" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8.90002 7.55999C9.21002 3.95999 11.06 2.48999 15.11 2.48999H15.24C19.71 2.48999 21.5 4.27999 21.5 8.74999V15.27C21.5 19.74 19.71 21.53 15.24 21.53H15.11C11.09 21.53 9.24002 20.08 8.91002 16.54",
    stroke: "currentColor",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    class: "transition-colors duration-200"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M2 12H14.88",
    stroke: "currentColor",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    class: "transition-colors duration-200"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.65 8.65002L16 12L12.65 15.35",
    stroke: "currentColor",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    class: "transition-colors duration-200"
  })
], -1)
const _hoisted_54 = { key: 0 }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0.5 1.25C0.5 1.05109 0.579018 0.860322 0.71967 0.71967C0.860322 0.579018 1.05109 0.5 1.25 0.5H1.808C2.758 0.5 3.328 1.139 3.653 1.733C3.87 2.129 4.027 2.588 4.15 3.004C4.18327 3.00137 4.21663 3.00004 4.25 3H16.748C17.578 3 18.178 3.794 17.95 4.593L16.122 11.002C15.9581 11.5769 15.6114 12.0827 15.1343 12.4428C14.6572 12.803 14.0758 12.9979 13.478 12.998H7.53C6.92749 12.998 6.34165 12.8002 5.86252 12.4349C5.3834 12.0696 5.0375 11.557 4.878 10.976L4.118 8.204L2.858 3.956L2.857 3.948C2.701 3.381 2.555 2.85 2.337 2.454C2.128 2.069 1.96 2 1.809 2H1.25C1.05109 2 0.860322 1.92098 0.71967 1.78033C0.579018 1.63968 0.5 1.44891 0.5 1.25ZM5.573 7.84L6.324 10.579C6.474 11.121 6.967 11.498 7.53 11.498H13.478C13.7497 11.498 14.014 11.4095 14.2309 11.2458C14.4478 11.0821 14.6054 10.8523 14.68 10.591L16.417 4.5H4.585L5.559 7.787L5.573 7.84ZM9 16C9 16.5304 8.78929 17.0391 8.41421 17.4142C8.03914 17.7893 7.53043 18 7 18C6.46957 18 5.96086 17.7893 5.58579 17.4142C5.21071 17.0391 5 16.5304 5 16C5 15.4696 5.21071 14.9609 5.58579 14.5858C5.96086 14.2107 6.46957 14 7 14C7.53043 14 8.03914 14.2107 8.41421 14.5858C8.78929 14.9609 9 15.4696 9 16ZM7.5 16C7.5 15.8674 7.44732 15.7402 7.35355 15.6464C7.25979 15.5527 7.13261 15.5 7 15.5C6.86739 15.5 6.74021 15.5527 6.64645 15.6464C6.55268 15.7402 6.5 15.8674 6.5 16C6.5 16.1326 6.55268 16.2598 6.64645 16.3536C6.74021 16.4473 6.86739 16.5 7 16.5C7.13261 16.5 7.25979 16.4473 7.35355 16.3536C7.44732 16.2598 7.5 16.1326 7.5 16ZM16 16C16 16.5304 15.7893 17.0391 15.4142 17.4142C15.0391 17.7893 14.5304 18 14 18C13.4696 18 12.9609 17.7893 12.5858 17.4142C12.2107 17.0391 12 16.5304 12 16C12 15.4696 12.2107 14.9609 12.5858 14.5858C12.9609 14.2107 13.4696 14 14 14C14.5304 14 15.0391 14.2107 15.4142 14.5858C15.7893 14.9609 16 15.4696 16 16ZM14.5 16C14.5 15.8674 14.4473 15.7402 14.3536 15.6464C14.2598 15.5527 14.1326 15.5 14 15.5C13.8674 15.5 13.7402 15.5527 13.6464 15.6464C13.5527 15.7402 13.5 15.8674 13.5 16C13.5 16.1326 13.5527 16.2598 13.6464 16.3536C13.7402 16.4473 13.8674 16.5 14 16.5C14.1326 16.5 14.2598 16.4473 14.3536 16.3536C14.4473 16.2598 14.5 16.1326 14.5 16Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("span", null, " carrinho ", -1)
const _hoisted_57 = {
  key: 0,
  class: "w-5 text-xs h-5 bg-red-600 rounded-full absolute top-[5%] right-1 text-white animate-bounce font-bold flex justify-center items-center"
}
const _hoisted_58 = { class: "p-4 font-inter" }
const _hoisted_59 = { class: "pb-5" }
const _hoisted_60 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_61 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z",
  style: {"fill":"currentcolor"}
}, null, -1)
const _hoisted_62 = [
  _hoisted_61
]
const _hoisted_63 = { class: "text-xl font-semibold" }
const _hoisted_64 = { class: "flex flex-col justify-between items-between h-full py-4" }
const _hoisted_65 = { class: "flex flex-col gap-2" }
const _hoisted_66 = { class: "p-4 border rounded-2xl" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("h6", {
  style: {"color":"#999"},
  class: "text-sm"
}, "Geral", -1)
const _hoisted_68 = { class: "flex gap-4 items-center" }
const _hoisted_69 = {
  style: {"width":"1.2rem","height":"1.2rem"},
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "#292f31"
}
const _hoisted_70 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.5,105.14a1.085,1.085,0,0,1-.743-.288L.308,98.818a.939.939,0,0,1,0-1.39,1.1,1.1,0,0,1,1.486,0l5.707,5.34,5.707-5.339a1.1,1.1,0,0,1,1.485,0,.938.938,0,0,1,0,1.39l-6.45,6.035A1.085,1.085,0,0,1,7.5,105.14Z",
  transform: "translate(-0.001 -97.14)"
}, null, -1)
const _hoisted_71 = [
  _hoisted_70
]
const _hoisted_72 = { class: "flex items-center gap-4" }
const _hoisted_73 = {
  fill: "none",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_74 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.5,105.14a1.085,1.085,0,0,1-.743-.288L.308,98.818a.939.939,0,0,1,0-1.39,1.1,1.1,0,0,1,1.486,0l5.707,5.34,5.707-5.339a1.1,1.1,0,0,1,1.485,0,.938.938,0,0,1,0,1.39l-6.45,6.035A1.085,1.085,0,0,1,7.5,105.14Z",
  transform: "translate(-0.001 -97.14)"
}, null, -1)
const _hoisted_75 = [
  _hoisted_74
]
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-4" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "23",
    height: "23",
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    class: "bell"
  }, [
    /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_1568_5365)" }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M21.7748 18.1822H20.6303V9.09086C20.6303 6.67982 19.6645 4.36752 17.9454 2.66265C16.2263 0.957784 13.8947 0 11.4635 0C9.03237 0 6.70076 0.957784 4.98166 2.66265C3.26256 4.36752 2.29677 6.67982 2.29677 9.09086V18.1812H1.15229C0.848759 18.1812 0.557656 18.3008 0.343024 18.5136C0.128392 18.7265 0.0078125 19.0152 0.0078125 19.3162C0.0078125 19.6172 0.128392 19.9059 0.343024 20.1188C0.557656 20.3316 0.848759 20.4512 1.15229 20.4512H6.87574C6.87574 21.6567 7.3586 22.8128 8.21811 23.6651C9.07761 24.5175 10.2433 24.9964 11.4589 24.9964C12.6744 24.9964 13.8401 24.5175 14.6996 23.6651C15.5591 22.8128 16.042 21.6567 16.042 20.4512H21.7748C22.0783 20.4512 22.3694 20.3316 22.5841 20.1188C22.7987 19.9059 22.9193 19.6172 22.9193 19.3162C22.9193 19.0152 22.7987 18.7265 22.5841 18.5136C22.3694 18.3008 22.0783 18.1812 21.7748 18.1812V18.1822ZM11.462 22.7274C10.8549 22.7274 10.2727 22.4883 9.84344 22.0625C9.41418 21.6368 9.17303 21.0595 9.17303 20.4574H13.7561C13.7562 20.7562 13.6967 21.0521 13.5811 21.328C13.4656 21.604 13.2962 21.8546 13.0828 22.0655C12.8694 22.2764 12.616 22.4434 12.3374 22.557C12.0587 22.6706 11.7602 22.7285 11.4589 22.7274H11.462ZM18.3372 18.1822H4.58366V9.09086C4.58366 8.19547 4.76149 7.30885 5.107 6.48162C5.45251 5.65439 5.95894 4.90275 6.59736 4.26961C7.23578 3.63648 7.9937 3.13425 8.82784 2.7916C9.66197 2.44895 10.556 2.27259 11.4589 2.27259C12.3617 2.27259 13.2558 2.44895 14.0899 2.7916C14.924 3.13425 15.6819 3.63648 16.3204 4.26961C16.9588 4.90275 17.4652 5.65439 17.8107 6.48162C18.1562 7.30885 18.3341 8.19547 18.3341 9.09086L18.3372 18.1822Z",
        fill: "#292F31"
      })
    ]),
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_1568_5365" }, [
        /*#__PURE__*/_createElementVNode("rect", {
          width: "22.9167",
          height: "25",
          fill: "white"
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h6", { class: "text-sm" }, "Notificações")
  ])
], -1)
const _hoisted_77 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "8",
  viewBox: "0 0 15 8",
  stroke: "none",
  style: {"transform":"rotate(270deg)"}
}
const _hoisted_78 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.5,105.14a1.085,1.085,0,0,1-.743-.288L.308,98.818a.939.939,0,0,1,0-1.39,1.1,1.1,0,0,1,1.486,0l5.707,5.34,5.707-5.339a1.1,1.1,0,0,1,1.485,0,.938.938,0,0,1,0,1.39l-6.45,6.035A1.085,1.085,0,0,1,7.5,105.14Z",
  transform: "translate(-0.001 -97.14)"
}, null, -1)
const _hoisted_79 = [
  _hoisted_78
]
const _hoisted_80 = { class: "p-4 border rounded-2xl" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("h6", {
  style: {"color":"#999"},
  class: "text-sm pb-4"
}, "Seus dados", -1)
const _hoisted_82 = { class: "flex items-center gap-4" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8.90002 7.55999C9.21002 3.95999 11.06 2.48999 15.11 2.48999H15.24C19.71 2.48999 21.5 4.27999 21.5 8.74999V15.27C21.5 19.74 19.71 21.53 15.24 21.53H15.11C11.09 21.53 9.24002 20.08 8.91002 16.54",
    stroke: "#292f31",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    class: "hover:parent:stroke-menu-hover"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M2 12H14.88",
    stroke: "#292f31",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    class: "hover:parent:stroke-menu-hover"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.65 8.65002L16 12L12.65 15.35",
    stroke: "#292f31",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    class: "hover:parent:stroke-menu-hover"
  })
], -1)
const _hoisted_84 = { class: "text-sm" }
const _hoisted_85 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "8",
  viewBox: "0 0 15 8",
  stroke: "none",
  style: {"transform":"rotate(270deg)"}
}
const _hoisted_86 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.5,105.14a1.085,1.085,0,0,1-.743-.288L.308,98.818a.939.939,0,0,1,0-1.39,1.1,1.1,0,0,1,1.486,0l5.707,5.34,5.707-5.339a1.1,1.1,0,0,1,1.485,0,.938.938,0,0,1,0,1.39l-6.45,6.035A1.085,1.085,0,0,1,7.5,105.14Z",
  transform: "translate(-0.001 -97.14)"
}, null, -1)
const _hoisted_87 = [
  _hoisted_86
]
const _hoisted_88 = {
  key: 0,
  class: "p-4 mt-4 rounded-xl flex items-start gap-4 bg-f5"
}
const _hoisted_89 = ["src"]
const _hoisted_90 = /*#__PURE__*/_createElementVNode("h6", { class: "" }, "Instalar app", -1)
const _hoisted_91 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 text-xs" }, "Adicione o nosso app a tela principal do seu dispositivo", -1)
const _hoisted_92 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_93 = /*#__PURE__*/_createElementVNode("path", {
  d: "M2 12H4V17H20V12H22V17C22 18.11 21.11 19 20 19H4C2.9 19 2 18.11 2 17V12M12 15L17.55 9.54L16.13 8.13L13 11.25V2H11V11.25L7.88 8.13L6.46 9.55L12 15Z",
  style: {"fill":"#fff"}
}, null, -1)
const _hoisted_94 = [
  _hoisted_93
]
const _hoisted_95 = { class: "web-layout__mobile-navigator bg-white p-4 lg:hidden fixed bottom-0 left-0 w-full box-shadow rounded-tl-3xl rounded-tr-3xl z-50" }
const _hoisted_96 = { class: "flex items-center justify-around font-inter" }
const _hoisted_97 = {
  stroke: "none",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "#292f31",
  xmlns: "http://www.w3.org/2000/svg",
  class: "header__svg"
}
const _hoisted_98 = {
  style: {"width":"1.2rem","height":"1.2rem"},
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "#292f31"
}
const _hoisted_99 = {
  key: 0,
  class: "flex flex-col items-center"
}
const _hoisted_100 = ["width", "height"]
const _hoisted_101 = /*#__PURE__*/_createElementVNode("path", { d: "M2 2h2v2H2V2Z" }, null, -1)
const _hoisted_102 = /*#__PURE__*/_createElementVNode("path", { d: "M6 0v6H0V0h6ZM5 1H1v4h4V1ZM4 12H2v2h2v-2Z" }, null, -1)
const _hoisted_103 = /*#__PURE__*/_createElementVNode("path", { d: "M6 10v6H0v-6h6Zm-5 1v4h4v-4H1Zm11-9h2v2h-2V2Z" }, null, -1)
const _hoisted_104 = /*#__PURE__*/_createElementVNode("path", { d: "M10 0v6h6V0h-6Zm5 1v4h-4V1h4ZM8 1V0h1v2H8v2H7V1h1Zm0 5V4h1v2H8ZM6 8V7h1V6h1v2h1V7h5v1h-4v1H7V8H6Zm0 0v1H2V8H1v1H0V7h3v1h3Zm10 1h-1V7h1v2Zm-1 0h-1v2h2v-1h-1V9Zm-4 0h2v1h-1v1h-1V9Zm2 3v-1h-1v1h-1v1H9v1h3v-2h1Zm0 0h3v1h-2v1h-1v-2Zm-4-1v1h1v-2H7v1h2Z" }, null, -1)
const _hoisted_105 = /*#__PURE__*/_createElementVNode("path", { d: "M7 12h1v3h4v1H7v-4Zm9 2v2h-3v-1h2v-1h1Z" }, null, -1)
const _hoisted_106 = {
  key: 0,
  class: "text-xs text-primary"
}
const _hoisted_107 = { key: 1 }
const _hoisted_108 = {
  stroke: "#292f31",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_109 = { key: 2 }
const _hoisted_110 = { class: "fill-menu hover:fill-menu-hover" }
const _hoisted_111 = /*#__PURE__*/_createStaticVNode("<svg width=\"19\" height=\"19\" viewBox=\"0 0 19 19\" class=\"fill-menu hover:fill-menu-hover\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_1528_5079)\"><path d=\"M0.745391 1.37012C0.745391 1.20436 0.811239 1.04539 0.928449 0.928175C1.04566 0.810965 1.20463 0.745117 1.37039 0.745117H1.91789C2.82664 0.745117 3.34914 1.33637 3.65164 1.92637C3.85789 2.33012 4.00664 2.82262 4.13039 3.25012H16.9991C17.1923 3.25017 17.3828 3.29499 17.5557 3.38105C17.7286 3.4671 17.8792 3.59206 17.9958 3.74611C18.1123 3.90016 18.1915 4.07911 18.2272 4.26893C18.2629 4.45874 18.2542 4.65425 18.2016 4.84012L16.3316 11.4339C16.1829 11.957 15.8676 12.4174 15.4336 12.7451C14.9996 13.0729 14.4705 13.2502 13.9266 13.2501H7.57789C7.02949 13.2503 6.49623 13.0702 6.06029 12.7374C5.62434 12.4047 5.3099 11.9379 5.16539 11.4089L4.36289 8.46512C4.35829 8.45192 4.35412 8.43858 4.35039 8.42512L3.06164 4.05387L2.93664 3.63262C2.81164 3.20012 2.70164 2.81762 2.53664 2.49637C2.33789 2.10887 2.15539 1.99637 1.91664 1.99637H1.36914C1.20338 1.99637 1.04441 1.93052 0.927199 1.81331C0.809988 1.6961 0.744141 1.53713 0.744141 1.37137L0.745391 1.37012ZM5.55539 8.08762L6.37164 11.0826C6.44401 11.347 6.60128 11.5803 6.81924 11.7465C7.03721 11.9128 7.30377 12.0027 7.57789 12.0026H13.9279C14.1997 12.0023 14.464 11.9135 14.6808 11.7495C14.8975 11.5855 15.0549 11.3553 15.1291 11.0939L16.9991 4.50012H4.49914L5.55539 8.08762ZM9.49914 16.3739C9.49914 16.8711 9.3016 17.3481 8.94997 17.6997C8.59834 18.0513 8.12142 18.2489 7.62414 18.2489C7.12686 18.2489 6.64995 18.0513 6.29832 17.6997C5.94668 17.3481 5.74914 16.8711 5.74914 16.3739C5.74914 15.8766 5.94668 15.3997 6.29832 15.048C6.64995 14.6964 7.12686 14.4989 7.62414 14.4989C8.12142 14.4989 8.59834 14.6964 8.94997 15.048C9.3016 15.3997 9.49914 15.8766 9.49914 16.3739ZM8.24914 16.3739C8.24914 16.2081 8.18329 16.0491 8.06608 15.9319C7.94887 15.8147 7.7899 15.7489 7.62414 15.7489C7.45838 15.7489 7.29941 15.8147 7.1822 15.9319C7.06499 16.0491 6.99914 16.2081 6.99914 16.3739C6.99914 16.5396 7.06499 16.6986 7.1822 16.8158C7.29941 16.933 7.45838 16.9989 7.62414 16.9989C7.7899 16.9989 7.94887 16.933 8.06608 16.8158C8.18329 16.6986 8.24914 16.5396 8.24914 16.3739ZM15.7491 16.3739C15.7491 16.8711 15.5516 17.3481 15.2 17.6997C14.8483 18.0513 14.3714 18.2489 13.8741 18.2489C13.3769 18.2489 12.8999 18.0513 12.5483 17.6997C12.1967 17.3481 11.9991 16.8711 11.9991 16.3739C11.9991 15.8766 12.1967 15.3997 12.5483 15.048C12.8999 14.6964 13.3769 14.4989 13.8741 14.4989C14.3714 14.4989 14.8483 14.6964 15.2 15.048C15.5516 15.3997 15.7491 15.8766 15.7491 16.3739ZM14.4991 16.3739C14.4991 16.2081 14.4333 16.0491 14.3161 15.9319C14.1989 15.8147 14.0399 15.7489 13.8741 15.7489C13.7084 15.7489 13.5494 15.8147 13.4322 15.9319C13.315 16.0491 13.2491 16.2081 13.2491 16.3739C13.2491 16.5396 13.315 16.6986 13.4322 16.8158C13.5494 16.933 13.7084 16.9989 13.8741 16.9989C14.0399 16.9989 14.1989 16.933 14.3161 16.8158C14.4333 16.6986 14.4991 16.5396 14.4991 16.3739Z\"></path></g><defs><clipPath id=\"clip0_1528_5079\"><rect width=\"19\" height=\"19\" fill=\"white\"></rect></clipPath></defs></svg>", 1)
const _hoisted_112 = {
  key: 0,
  class: "w-5 text-sm h-5 bg-red-600 rounded-full absolute top-[-30%] right-1 text-white animate-bounce font-bold"
}
const _hoisted_113 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-menu hover:text-menu-hover text-xs" }, "Carrinho", -1)
const _hoisted_114 = /*#__PURE__*/_createElementVNode("div", { class: "absolute top-3 bg-gray-300 w-10 h-1 left-1/2 -translate-x-1/2" }, null, -1)
const _hoisted_115 = { class: "pt-3 px-4 font-inter" }
const _hoisted_116 = { class: "" }
const _hoisted_117 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_118 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z",
  style: {"fill":"currentcolor"}
}, null, -1)
const _hoisted_119 = [
  _hoisted_118
]
const _hoisted_120 = { class: "grid grid-cols-12 font-medium" }
const _hoisted_121 = /*#__PURE__*/_createElementVNode("h6", null, "Sobre", -1)
const _hoisted_122 = [
  _hoisted_121
]
const _hoisted_123 = /*#__PURE__*/_createElementVNode("h6", null, "Horário", -1)
const _hoisted_124 = [
  _hoisted_123
]
const _hoisted_125 = /*#__PURE__*/_createElementVNode("h6", null, "Redes sociais", -1)
const _hoisted_126 = [
  _hoisted_125
]
const _hoisted_127 = { class: "pt-4" }
const _hoisted_128 = {
  key: 0,
  class: "flex flex-col gap-4 enter-content-animation-left"
}
const _hoisted_129 = /*#__PURE__*/_createElementVNode("div", { class: "flex gap-2 items-center pb-2" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96451 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.7473 9.41498 20.7192 6.93661 18.8913 5.10872C17.0634 3.28084 14.585 2.25273 12 2.25ZM11.625 6.75C11.8475 6.75 12.065 6.81598 12.25 6.9396C12.435 7.06321 12.5792 7.23891 12.6644 7.44448C12.7495 7.65005 12.7718 7.87625 12.7284 8.09448C12.685 8.31271 12.5778 8.51316 12.4205 8.6705C12.2632 8.82783 12.0627 8.93498 11.8445 8.97838C11.6263 9.02179 11.4001 8.99951 11.1945 8.91436C10.9889 8.82922 10.8132 8.68502 10.6896 8.50002C10.566 8.31501 10.5 8.0975 10.5 7.875C10.5 7.57663 10.6185 7.29048 10.8295 7.0795C11.0405 6.86853 11.3266 6.75 11.625 6.75ZM12.75 17.25C12.3522 17.25 11.9706 17.092 11.6893 16.8107C11.408 16.5294 11.25 16.1478 11.25 15.75V12C11.0511 12 10.8603 11.921 10.7197 11.7803C10.579 11.6397 10.5 11.4489 10.5 11.25C10.5 11.0511 10.579 10.8603 10.7197 10.7197C10.8603 10.579 11.0511 10.5 11.25 10.5C11.6478 10.5 12.0294 10.658 12.3107 10.9393C12.592 11.2206 12.75 11.6022 12.75 12V15.75C12.9489 15.75 13.1397 15.829 13.2803 15.9697C13.421 16.1103 13.5 16.3011 13.5 16.5C13.5 16.6989 13.421 16.8897 13.2803 17.0303C13.1397 17.171 12.9489 17.25 12.75 17.25Z",
      fill: "#323232"
    })
  ]),
  /*#__PURE__*/_createElementVNode("h6", { class: "font-medium" }, "Sobre nós")
], -1)
const _hoisted_130 = {
  style: {"font-size":"13px","color":"#575757","background":"#f5f5f5"},
  class: "p-3 rounded-lg text-sm font-medium"
}
const _hoisted_131 = /*#__PURE__*/_createElementVNode("div", { class: "flex gap-2 items-center pb-2" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    stroke: "#323232"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M9.9999 11.1912C11.4358 11.1912 12.5999 10.0272 12.5999 8.59121C12.5999 7.15527 11.4358 5.99121 9.9999 5.99121C8.56396 5.99121 7.3999 7.15527 7.3999 8.59121C7.3999 10.0272 8.56396 11.1912 9.9999 11.1912Z",
      "stroke-width": "1.5",
      stroke: "#323232"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M3.01675 7.07533C4.65842 -0.141339 15.3501 -0.133006 16.9834 7.08366C17.9418 11.317 15.3084 14.9003 13.0001 17.117C11.3251 18.7337 8.67508 18.7337 6.99175 17.117C4.69175 14.9003 2.05842 11.3087 3.01675 7.07533Z",
      "stroke-width": "1.5"
    })
  ]),
  /*#__PURE__*/_createElementVNode("h6", { class: "font-medium" }, "Endereço")
], -1)
const _hoisted_132 = {
  style: {"color":"#575757","font-size":"13px"},
  class: "text-sm text-slate-500 font-medium"
}
const _hoisted_133 = {
  key: 1,
  class: "enter-content-animation-left"
}
const _hoisted_134 = { key: 0 }
const _hoisted_135 = {
  key: 0,
  style: {"background":"#292f31"},
  class: "font-semibold text-sm p-2 text-white rounded-lg"
}
const _hoisted_136 = {
  key: 1,
  style: {"background":"#292f31"},
  class: "font-semibold text-sm p-2 px-4 text-white rounded-lg"
}
const _hoisted_137 = {
  key: 1,
  style: {"background":"#292f31"},
  class: "font-semibold text-sm p-2 px-4 text-white rounded-lg"
}
const _hoisted_138 = {
  key: 2,
  class: "enter-content-animation-left"
}
const _hoisted_139 = { class: "flex items-center gap-4" }
const _hoisted_140 = ["href"]
const _hoisted_141 = /*#__PURE__*/_createElementVNode("svg", {
  width: "13",
  height: "24",
  viewBox: "0 0 13 24",
  fill: "#292f31",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_691_1942)" }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M11.899 0.277345H8.933C5.601 0.277345 3.448 2.48634 3.448 5.90534V8.50034H0.466001C0.40472 8.50034 0.344043 8.51243 0.28744 8.53591C0.230837 8.55939 0.179421 8.59381 0.136136 8.63719C0.092851 8.68056 0.0585457 8.73205 0.0351859 8.78871C0.0118261 8.84536 -0.00013043 8.90606 1.07305e-06 8.96734V12.7273C1.07305e-06 12.8509 0.0490971 12.9695 0.136489 13.0569C0.223881 13.1442 0.34241 13.1933 0.466001 13.1933H3.448V22.6773C3.448 22.7385 3.46006 22.7991 3.48347 22.8557C3.50689 22.9122 3.54122 22.9636 3.58449 23.0069C3.62776 23.0501 3.67913 23.0845 3.73567 23.1079C3.79221 23.1313 3.8528 23.1433 3.914 23.1433H7.804C7.92759 23.1433 8.04612 23.0942 8.13351 23.0069C8.22091 22.9195 8.27 22.8009 8.27 22.6773V13.1933H11.756C11.8796 13.1933 11.9981 13.1442 12.0855 13.0569C12.1729 12.9695 12.222 12.8509 12.222 12.7273V8.96734C12.222 8.84349 12.1728 8.72471 12.0852 8.63713C11.9976 8.54955 11.8789 8.50034 11.755 8.50034H8.271V6.30034C8.271 5.24334 8.523 4.70634 9.9 4.70634H11.9C12.0236 4.70634 12.1421 4.65725 12.2295 4.56986C12.3169 4.48246 12.366 4.36394 12.366 4.24035V0.748345C12.3667 0.686645 12.3551 0.625428 12.3319 0.568246C12.3087 0.511065 12.2744 0.459057 12.2309 0.41524C12.1875 0.371424 12.1358 0.336671 12.0788 0.313C12.0218 0.289328 11.9607 0.277209 11.899 0.277345Z" })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_691_1942" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "12.364",
        height: "22.869",
        fill: "white",
        transform: "translate(0 0.277344)"
      })
    ])
  ])
], -1)
const _hoisted_142 = [
  _hoisted_141
]
const _hoisted_143 = ["href"]
const _hoisted_144 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5.45993 2H4.0499C3.1199 2 2.64991 3.13 3.30991 3.79L9.03989 9.52C10.6799 11.16 13.3299 11.16 14.9699 9.52L20.6999 3.79C21.3599 3.13 20.8899 2 19.9599 2H18.5499C17.7199 2 16.9199 2.33 16.3299 2.92L12.7499 6.5C12.3399 6.91 11.6799 6.91 11.2699 6.5L7.68991 2.92C7.08991 2.33 6.28993 2 5.45993 2Z",
    fill: "#292f31"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5.45993 21.97H4.0499C3.1199 21.97 2.64991 20.84 3.30991 20.18L9.03989 14.45C10.6799 12.81 13.3299 12.81 14.9699 14.45L20.6999 20.18C21.3599 20.84 20.8899 21.97 19.9599 21.97H18.5499C17.7199 21.97 16.9199 21.64 16.3299 21.05L12.7499 17.47C12.3399 17.06 11.6799 17.06 11.2699 17.47L7.68991 21.05C7.08991 21.64 6.28993 21.97 5.45993 21.97Z",
    fill: "#292f31"
  })
], -1)
const _hoisted_145 = [
  _hoisted_144
]
const _hoisted_146 = ["href"]
const _hoisted_147 = /*#__PURE__*/_createElementVNode("svg", {
  width: "19",
  height: "20",
  viewBox: "0 0 19 20",
  fill: "#292f31",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_691_1947)" }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M16.19 0.277344H2.779C2.04221 0.278138 1.33582 0.57118 0.814827 1.09217C0.293836 1.61316 0.000794101 2.31955 0 3.05634L0 16.4673C0.000794101 17.2041 0.293836 17.9105 0.814827 18.4315C1.33582 18.9525 2.04221 19.2456 2.779 19.2463H16.19C16.9268 19.2456 17.6332 18.9525 18.1542 18.4315C18.6752 17.9105 18.9682 17.2041 18.969 16.4673V3.05634C18.9682 2.31955 18.6752 1.61316 18.1542 1.09217C17.6332 0.57118 16.9268 0.278138 16.19 0.277344V0.277344ZM9.521 14.7253C8.53209 14.7253 7.56539 14.4321 6.74315 13.8827C5.9209 13.3333 5.28004 12.5524 4.9016 11.6388C4.52316 10.7251 4.42415 9.7198 4.61707 8.74989C4.81 7.77999 5.2862 6.88907 5.98547 6.18981C6.68473 5.49055 7.57564 5.01434 8.54555 4.82142C9.51545 4.62849 10.5208 4.72751 11.4344 5.10595C12.348 5.48438 13.1289 6.12525 13.6783 6.94749C14.2278 7.76974 14.521 8.73644 14.521 9.72534C14.5191 11.0509 13.9918 12.3216 13.0545 13.2588C12.1172 14.1961 10.8465 14.7235 9.521 14.7253ZM15.078 5.83434C14.7483 5.83434 14.426 5.73658 14.1519 5.5534C13.8777 5.37023 13.6641 5.10988 13.5379 4.80528C13.4117 4.50067 13.3787 4.16549 13.443 3.84213C13.5074 3.51876 13.6661 3.22173 13.8993 2.9886C14.1324 2.75546 14.4294 2.5967 14.7528 2.53237C15.0762 2.46805 15.4113 2.50107 15.7159 2.62724C16.0205 2.75341 16.2809 2.96707 16.4641 3.24121C16.6472 3.51534 16.745 3.83764 16.745 4.16734C16.7445 4.6093 16.5687 5.033 16.2562 5.34551C15.9437 5.65801 15.52 5.83381 15.078 5.83434Z" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M15.0794 3.61133C14.9695 3.61133 14.862 3.64394 14.7705 3.70503C14.6791 3.76613 14.6078 3.85296 14.5658 3.95456C14.5237 4.05616 14.5127 4.16794 14.5341 4.27579C14.5556 4.38365 14.6085 4.48272 14.6863 4.56048C14.764 4.63824 14.8631 4.69119 14.971 4.71265C15.0788 4.7341 15.1906 4.72309 15.2922 4.68101C15.3938 4.63893 15.4807 4.56766 15.5417 4.47623C15.6028 4.38479 15.6354 4.27729 15.6354 4.16733C15.6354 4.01987 15.5769 3.87845 15.4726 3.77418C15.3683 3.66991 15.2269 3.61133 15.0794 3.61133Z" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M9.52281 5.83398C8.75344 5.83398 8.00135 6.06212 7.36164 6.48956C6.72194 6.917 6.22334 7.52455 5.92892 8.23535C5.63449 8.94616 5.55746 9.72829 5.70756 10.4829C5.85766 11.2375 6.22814 11.9306 6.77217 12.4746C7.31619 13.0187 8.00933 13.3891 8.76391 13.5392C9.5185 13.6893 10.3006 13.6123 11.0114 13.3179C11.7222 13.0234 12.3298 12.5249 12.7572 11.8851C13.1847 11.2454 13.4128 10.4934 13.4128 9.72398C13.4115 8.6927 13.0012 7.70404 12.272 6.97481C11.5428 6.24558 10.5541 5.83531 9.52281 5.83398Z" })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_691_1947" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "18.968",
        height: "18.968",
        fill: "white",
        transform: "translate(0 0.277344)"
      })
    ])
  ])
], -1)
const _hoisted_148 = [
  _hoisted_147
]
const _hoisted_149 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_150 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z",
  style: {"fill":"#fff"}
}, null, -1)
const _hoisted_151 = [
  _hoisted_150
]
const _hoisted_152 = /*#__PURE__*/_createElementVNode("div", {
  style: {"z-index":"200","top":"80%"},
  class: "bg-black bg-opacity-50 p-2 px-4 rounded-3xl text-white absolute transform -translate-x-1/2 left-1/2"
}, [
  /*#__PURE__*/_createTextVNode(" Escaneie o "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-primary" }, "qrcode")
], -1)
const _hoisted_153 = /*#__PURE__*/_createElementVNode("div", { class: "qr-code-reader-focus" }, null, -1)
const _hoisted_154 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.6rem","height":"1.6rem"}
}
const _hoisted_155 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12,5A2,2 0 0,1 14,7C14,7.24 13.96,7.47 13.88,7.69C17.95,8.5 21,11.91 21,16H3C3,11.91 6.05,8.5 10.12,7.69C10.04,7.47 10,7.24 10,7A2,2 0 0,1 12,5M22,19H2V17H22V19M12,9.5C8.89,9.5 6.25,11.39 5.34,14H18.66C17.75,11.39 15.11,9.5 12,9.5Z",
  style: {"fill":"#fff"}
}, null, -1)
const _hoisted_156 = [
  _hoisted_155
]
const _hoisted_157 = /*#__PURE__*/_createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"25\" height=\"24\" viewBox=\"0 0 25 24\" fill=\"none\"><path d=\"M19.0156 8C20.6725 8 22.0156 6.65685 22.0156 5C22.0156 3.34315 20.6725 2 19.0156 2C17.3588 2 16.0156 3.34315 16.0156 5C16.0156 6.65685 17.3588 8 19.0156 8Z\" stroke=\"#292f31\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M7.01562 13H12.0156\" stroke=\"#292f31\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M7.01562 17H16.0156\" stroke=\"#292f31\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M14.0156 2H9.01562C4.01562 2 2.01562 4 2.01562 9V15C2.01562 20 4.01562 22 9.01562 22H15.0156C20.0156 22 22.0156 20 22.0156 15V10\" stroke=\"#292f31\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg>", 1)
const _hoisted_158 = { class: "text-xs" }
const _hoisted_159 = /*#__PURE__*/_createElementVNode("div", { class: "absolute top-3 bg-gray-300 w-10 h-1 left-1/2 -translate-x-1/2" }, null, -1)
const _hoisted_160 = { class: "p-4 py-8 font-inter flex flex-col gap-4" }
const _hoisted_161 = { class: "flex items-center justify-between pb-2" }
const _hoisted_162 = { class: "font-bold text-neutral-800 text-lg" }
const _hoisted_163 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_164 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z",
  style: {"fill":"currentcolor"}
}, null, -1)
const _hoisted_165 = [
  _hoisted_164
]
const _hoisted_166 = { class: "flex gap-4 items-center" }
const _hoisted_167 = ["src"]
const _hoisted_168 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "Instale o nosso app e receba notificações, encontre promoções, descontos e muito mais!", -1)
const _hoisted_169 = { class: "flex justify-center" }
const _hoisted_170 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_171 = /*#__PURE__*/_createElementVNode("path", {
  d: "M2 12H4V17H20V12H22V17C22 18.11 21.11 19 20 19H4C2.9 19 2 18.11 2 17V12M12 15L17.55 9.54L16.13 8.13L13 11.25V2H11V11.25L7.88 8.13L6.46 9.55L12 15Z",
  style: {"fill":"#fff"}
}, null, -1)
const _hoisted_172 = [
  _hoisted_171
]
const _hoisted_173 = /*#__PURE__*/_createElementVNode("audio", {
  src: "/assets/audio/notification.wav",
  id: "notificationAudio"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_RouterView = _resolveComponent("RouterView")!
  const _component_MyModal = _resolveComponent("MyModal")!
  const _component_AuthModal = _resolveComponent("AuthModal")!
  const _component_CartSidebar = _resolveComponent("CartSidebar")!
  const _component_NotificationsModal = _resolveComponent("NotificationsModal")!
  const _component_QrcodeStream = _resolveComponent("QrcodeStream")!
  const _component_CustomerRequestModal = _resolveComponent("CustomerRequestModal")!
  const _component_CentralLoader = _resolveComponent("CentralLoader")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["web-layout", [$setup.designCustom.menuFixed ? `with-fixed-nav ${!$setup.hideNav ? 'show-nav' : 'hide-nav'}`:`${!$setup.hideNav ? 'show-nav' : 'hide-nav'}`, `sf-template-${$setup.storefrontTemplate}`]])
  }, [
    _createElementVNode("nav", {
      class: _normalizeClass(["w-full web-layout__nav font-roboto py-0 lg:flex-row flex-col font-inter pt-4 xl:pt-6", $setup.designCustom.menuFixed ? ('fixed-nav rounded-bl-2xl rounded-br-2xl bg-white transition-box-shadow duration-200 z-10' + ($setup.isScrolled ? ' box-shadow':'')) :'no-fixed']),
      style: _normalizeStyle({display: $setup.hideNav ? 'none' : 'flex'}),
      id: "nav"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("ul", _hoisted_2, [
          _createElementVNode("li", _hoisted_3, [
            _createVNode(_component_router_link, { to: { name: 'home' } }, {
              default: _withCtx(() => [
                ($setup.restaurant.id)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: $setup.designCustom.logo ? $setup.designCustom.logo : '/assets/logo_horizontal_black.png',
                      alt: "logo"
                    }, null, 8, _hoisted_4))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5))
              ]),
              _: 1
            }),
            _hoisted_6
          ]),
          (!$setup.customer.cpf)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "text-right relative web-layout__nav__left__profile hidden",
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.isAuthModalOpen = true))
              }, _hoisted_9))
            : (_openBlock(), _createElementBlock("button", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("span", _hoisted_12, _toDisplayString($setup.customer.name?.split(' ').slice(0, 2).join(' ')), 1)
              ]))
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("form", {
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.$router.push({ name: 'products', params: { search: $setup.searchQuery || '' } })), ["prevent"])),
            class: "web-layout__search w-full"
          }, [
            _hoisted_14,
            _withDirectives(_createElementVNode("input", {
              onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.onInputSearch && $setup.onInputSearch(...args))),
              id: "search-products",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.searchQuery) = $event)),
              type: "text",
              placeholder: "Buscar por produtos ou categorias",
              class: "rounded-xl w-full h-full p-4 pl-10 focus:placeholder-opacity-0"
            }, null, 544), [
              [_vModelText, $setup.searchQuery]
            ]),
            ($setup.searchQuery)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.clearSearchProduct && $setup.clearSearchProduct(...args))),
                  class: "absolute right-4 top-1/2 -translate-y-1/2 erase-icon"
                }, _hoisted_16))
              : _createCommentVNode("", true)
          ], 32),
          _createElementVNode("div", _hoisted_17, [
            (!$setup.restaurant.restaurantConfig?.isDigitalCatalog)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.isMenuOpen = true)),
                  class: "flex items-center gap-2"
                }, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_18, _hoisted_20)),
                  _hoisted_21
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_22)),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("button", {
                class: "relative",
                onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.isNotificationsModalOpen = true))
              }, [
                _hoisted_24,
                ($setup.unreadNotificationsLength)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString($setup.unreadNotificationsLength), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("button", {
                onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.isInfoModalOpen = true))
              }, _hoisted_27)
            ])
          ])
        ]),
        _createElementVNode("ul", _hoisted_28, [
          _createElementVNode("li", _hoisted_29, [
            _createVNode(_component_router_link, {
              to: { name: 'categories' },
              class: "flex items-center gap-2 web-layout__nav__right--category"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock("svg", _hoisted_30, [
                  _createElementVNode("path", {
                    d: "M4 8.78516H6C8 8.78516 9 7.78516 9 5.78516V3.78516C9 1.78516 8 0.785156 6 0.785156H4C2 0.785156 1 1.78516 1 3.78516V5.78516C1 7.78516 2 8.78516 4 8.78516ZM16 8.78516H18C20 8.78516 21 7.78516 21 5.78516V3.78516C21 1.78516 20 0.785156 18 0.785156H16C14 0.785156 13 1.78516 13 3.78516V5.78516C13 7.78516 14 8.78516 16 8.78516ZM16 20.7852H18C20 20.7852 21 19.7852 21 17.7852V15.7852C21 13.7852 20 12.7852 18 12.7852H16C14 12.7852 13 13.7852 13 15.7852V17.7852C13 19.7852 14 20.7852 16 20.7852ZM4 20.7852H6C8 20.7852 9 19.7852 9 17.7852V15.7852C9 13.7852 8 12.7852 6 12.7852H4C2 12.7852 1 13.7852 1 15.7852V17.7852C1 19.7852 2 20.7852 4 20.7852Z",
                    stroke: "#fff",
                    "stroke-width": "1.5",
                    "stroke-miterlimit": "10",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    class: _normalizeClass(_ctx.$route.path.startsWith('/categor') ? 'fill-menu-hover':'fill-menu hover:fill-menu-hover')
                  }, null, 2)
                ])),
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.$route.path.startsWith('/categor') ? 'text-menu-hover' : 'text-menu hover:text-menu-hover')
                }, " categorias ", 2)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_31, [
            _createElementVNode("a", {
              href: "#",
              onClick: _cache[8] || (_cache[8] = ($event: any) => {$event.preventDefault();$setup.isMenuDropdownOpen = !$setup.isMenuDropdownOpen}),
              class: _normalizeClass(["flex items-center gap-2 cursor-pointer hover:stroke-menu-hover", $setup.isMenuDropdownOpen ? 'text-menu-hover' : 'text-menu hover:text-menu-hover'])
            }, _hoisted_34, 2),
            _createElementVNode("ul", {
              class: _normalizeClass(["absolute bg-white box-shadow py-4 w-80 rounded-xl font-inter z-10 left-1/2 -translate-x-1/2", $setup.isMenuDropdownOpen ? '':'hidden'])
            }, [
              _createElementVNode("h4", _hoisted_35, "Bem-vindo(a), " + _toDisplayString($setup.customer.name?.split(' ').slice(0, 2).join(' ')), 1),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", null, [
                    ($setup.deferredPrompt)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                          _createElementVNode("img", {
                            class: "rounded-lg",
                            src: $setup.designCustom.pwaLogo ? `${$setup.apiBaseUrl}/storage/${$setup.designCustom.pwaLogo}`:'/assets/favicon.png',
                            style: {"height":"4.5rem","width":"4.5rem"}
                          }, null, 8, _hoisted_39),
                          _createElementVNode("div", null, [
                            _hoisted_40,
                            _hoisted_41,
                            _createElementVNode("button", {
                              id: "install-pwa-btn",
                              style: {"padding":".4rem 2rem"},
                              class: "text-white rounded-3xl flex items-center gap-2 w-full mt-4 text-white rounded-xl font-medium transition duration-200 bg-primary justify-center text-sm",
                              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => ($setup.installPWA && $setup.installPWA(...args)))
                            }, [
                              (_openBlock(), _createElementBlock("svg", _hoisted_42, _hoisted_44)),
                              _createTextVNode(" Instalar ")
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_RouterLink, {
                      onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.isMenuDropdownOpen = false)),
                      to: { name: 'categories'},
                      class: _normalizeClass(["flex items-center justify-between hover:stroke-secondary", _ctx.$route.path.startsWith('/categor') ? 'text-menu-hover' : 'text-menu hover:text-menu-hover hover:fill-menu-hover transition-color duration-200']),
                      style: {"padding":"1.5rem 2rem"}
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_45, [
                          (_openBlock(), _createElementBlock("svg", _hoisted_46, [
                            _createElementVNode("path", {
                              d: "M4 8.78516H6C8 8.78516 9 7.78516 9 5.78516V3.78516C9 1.78516 8 0.785156 6 0.785156H4C2 0.785156 1 1.78516 1 3.78516V5.78516C1 7.78516 2 8.78516 4 8.78516ZM16 8.78516H18C20 8.78516 21 7.78516 21 5.78516V3.78516C21 1.78516 20 0.785156 18 0.785156H16C14 0.785156 13 1.78516 13 3.78516V5.78516C13 7.78516 14 8.78516 16 8.78516ZM16 20.7852H18C20 20.7852 21 19.7852 21 17.7852V15.7852C21 13.7852 20 12.7852 18 12.7852H16C14 12.7852 13 13.7852 13 15.7852V17.7852C13 19.7852 14 20.7852 16 20.7852ZM4 20.7852H6C8 20.7852 9 19.7852 9 17.7852V15.7852C9 13.7852 8 12.7852 6 12.7852H4C2 12.7852 1 13.7852 1 15.7852V17.7852C1 19.7852 2 20.7852 4 20.7852Z",
                              stroke: "#fff",
                              "stroke-width": "1.5",
                              "stroke-miterlimit": "10",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              class: _normalizeClass([[ _ctx.$route.path.startsWith('/categor') ? 'fill-menu-hover' : 'fill-menu hover:fill-menu-hover' ], "hover:parent:fill-menu-hover"])
                            }, null, 2)
                          ])),
                          _hoisted_47
                        ])
                      ]),
                      _: 1
                    }, 8, ["class"]),
                    (!$setup.restaurant.restaurantConfig?.isDigitalCatalog)
                      ? (_openBlock(), _createBlock(_component_RouterLink, {
                          key: 1,
                          onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.isMenuDropdownOpen = false)),
                          to: { name: 'orders'},
                          class: _normalizeClass(["flex items-center justify-between transition-color duration-200", _ctx.$route.path.startsWith('/orders') ? 'text-menu-hover' : 'text-menu hover:text-menu-hover']),
                          style: {"padding":"1.5rem 2rem"}
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_48, [
                              _hoisted_49,
                              _createElementVNode("div", null, [
                                _createElementVNode("h6", {
                                  class: _normalizeClass(_ctx.$route.path.startsWith('/orders') ? 'text-menu-hover':'')
                                }, "Pedidos", 2)
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["class"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      onClick: _cache[12] || (_cache[12] = ($event: any) => {$setup.isNotificationsModalOpen = true;$setup.isMenuDropdownOpen = false;}),
                      class: "flex w-full items-center justify-between py-6 px-8 hover:text-menu-hover hover:stroke-menu-hover transition-color duration-200",
                      style: {"padding":"1.5rem 2rem"}
                    }, _hoisted_51),
                    _createElementVNode("button", {
                      onClick: _cache[13] || (_cache[13] = ($event: any) => {$setup.customer?.cpf ? $setup.logout() : $setup.isAuthModalOpen = true; $setup.isMenuDropdownOpen = false;}),
                      class: "flex w-full items-center justify-between py-6 rounded-xl px-8 hover:text-menu-hover hover:stroke-menu-hover transition-color duration-200",
                      style: {"padding":"1.5rem 2rem"}
                    }, [
                      _createElementVNode("div", _hoisted_52, [
                        _hoisted_53,
                        _createElementVNode("div", null, [
                          _createElementVNode("h6", null, _toDisplayString($setup.customer?.cpf ? 'Sair' : 'Login'), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ], 2)
          ]),
          (!$setup.restaurant.restaurantConfig?.isDigitalCatalog)
            ? (_openBlock(), _createElementBlock("li", _hoisted_54, [
                _createElementVNode("button", {
                  class: "web-layout__nav__right--cart relative flex items-center gap-2 text-menu hover:text-menu-hover",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => ($setup.isCartOpen = true))
                }, [
                  _hoisted_55,
                  _hoisted_56,
                  ($setup.cart.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, _toDisplayString($setup.cart.length), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 6),
    _createElementVNode("main", null, [
      _createVNode(_component_RouterView),
      ($setup.business?.baseUrls)
        ? (_openBlock(), _createBlock(_component_MyModal, {
            key: 0,
            id: 'menu-modal',
            width: '35rem',
            height: '23.5rem',
            isOpen: $setup.isMenuOpen,
            toggleModal: (value) => $setup.isMenuOpen = value,
            zIndex: 120
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("button", {
                    class: "transition duration-200 hover:text-primary",
                    onClick: _cache[15] || (_cache[15] = ($event: any) => ($setup.isMenuOpen = false))
                  }, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_60, _hoisted_62))
                  ])
                ]),
                _createElementVNode("h4", _hoisted_63, "Bem-vindo(a), " + _toDisplayString($setup.customer.name?.split(' ').slice(0, 2).join(' ')), 1),
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("div", _hoisted_66, [
                      _hoisted_67,
                      _createVNode(_component_RouterLink, {
                        onClick: _cache[16] || (_cache[16] = ($event: any) => ($setup.isMenuOpen = false)),
                        to: { name: 'categories'},
                        class: "flex items-center justify-between p-4"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_68, [
                            (_openBlock(), _createElementBlock("svg", _hoisted_69, [
                              _createElementVNode("path", {
                                d: "M4 8.78516H6C8 8.78516 9 7.78516 9 5.78516V3.78516C9 1.78516 8 0.785156 6 0.785156H4C2 0.785156 1 1.78516 1 3.78516V5.78516C1 7.78516 2 8.78516 4 8.78516ZM16 8.78516H18C20 8.78516 21 7.78516 21 5.78516V3.78516C21 1.78516 20 0.785156 18 0.785156H16C14 0.785156 13 1.78516 13 3.78516V5.78516C13 7.78516 14 8.78516 16 8.78516ZM16 20.7852H18C20 20.7852 21 19.7852 21 17.7852V15.7852C21 13.7852 20 12.7852 18 12.7852H16C14 12.7852 13 13.7852 13 15.7852V17.7852C13 19.7852 14 20.7852 16 20.7852ZM4 20.7852H6C8 20.7852 9 19.7852 9 17.7852V15.7852C9 13.7852 8 12.7852 6 12.7852H4C2 12.7852 1 13.7852 1 15.7852V17.7852C1 19.7852 2 20.7852 4 20.7852Z",
                                stroke: "#fff",
                                "stroke-width": "1.5",
                                "stroke-miterlimit": "10",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                class: _normalizeClass([ _ctx.$route.path.startsWith('/categor') ? 'fill-secondary' : 'fill-menu hover:fill-menu-hover' ])
                              }, null, 2)
                            ])),
                            _createElementVNode("h6", {
                              class: _normalizeClass(["text-sm", _ctx.$route.path.startsWith('/categor') ? 'text-secondary' : 'text-menu hover:text-menu-hover'])
                            }, "Categorias", 2)
                          ]),
                          (_openBlock(), _createElementBlock("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "15",
                            height: "8",
                            viewBox: "0 0 15 8",
                            stroke: "none",
                            style: {"transform":"rotate(270deg)"},
                            class: _normalizeClass(_ctx.$route.path.startsWith('/categor') ? 'fill-secondary':'')
                          }, _hoisted_71, 2))
                        ]),
                        _: 1
                      }),
                      (!$setup.restaurant.restaurantConfig?.isDigitalCatalog)
                        ? (_openBlock(), _createBlock(_component_RouterLink, {
                            key: 0,
                            onClick: _cache[17] || (_cache[17] = ($event: any) => ($setup.isMenuOpen = false)),
                            to: { name: 'orders'},
                            class: "flex items-center justify-between p-4"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_72, [
                                (_openBlock(), _createElementBlock("svg", _hoisted_73, [
                                  _createElementVNode("path", {
                                    fill: "none",
                                    d: "M8 7H16M9 11H15M6.73 19.7C7.55 18.82 8.8 18.89 9.52 19.85L10.53 21.2C11.34 22.27 12.65 22.27 13.46 21.2L14.47 19.85C15.19 18.89 16.44 18.82 17.26 19.7C19.04 21.6 20.49 20.97 20.49 18.31V7.04C20.5 3.01 19.56 2 15.78 2H8.22C4.44 2 3.5 3.01 3.5 7.04V18.3C3.5 20.97 4.96 21.59 6.73 19.7Z",
                                    "stroke-width": "1.5",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    class: _normalizeClass([ _ctx.$route.path.startsWith('/orders') ? 'stroke-secondary' : 'stroke-menu hover:stroke-menu-hover' ])
                                  }, null, 2)
                                ])),
                                _createElementVNode("div", null, [
                                  _createElementVNode("h6", {
                                    class: _normalizeClass(["text-sm", _ctx.$route.path.startsWith('/orders') ? 'text-secondary':''])
                                  }, "Pedidos", 2)
                                ])
                              ]),
                              (_openBlock(), _createElementBlock("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "15",
                                height: "8",
                                viewBox: "0 0 15 8",
                                stroke: "none",
                                style: {"transform":"rotate(270deg)"},
                                class: _normalizeClass(_ctx.$route.path.startsWith('/orders') ? 'fill-secondary':'')
                              }, _hoisted_75, 2))
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        onClick: _cache[18] || (_cache[18] = ($event: any) => ($setup.isNotificationsModalOpen = true)),
                        class: "flex w-full items-center justify-between p-4"
                      }, [
                        _hoisted_76,
                        (_openBlock(), _createElementBlock("svg", _hoisted_77, _hoisted_79))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_80, [
                      _hoisted_81,
                      _createElementVNode("button", {
                        onClick: _cache[19] || (_cache[19] = ($event: any) => ($setup.customer?.cpf ? $setup.logout() : $setup.isAuthModalOpen = true)),
                        class: "flex w-full items-center justify-between bg-f5 p-4 rounded-xl"
                      }, [
                        _createElementVNode("div", _hoisted_82, [
                          _hoisted_83,
                          _createElementVNode("div", null, [
                            _createElementVNode("h6", _hoisted_84, _toDisplayString($setup.customer?.cpf ? 'Sair' : 'Login'), 1)
                          ])
                        ]),
                        (_openBlock(), _createElementBlock("svg", _hoisted_85, _hoisted_87))
                      ])
                    ])
                  ]),
                  ($setup.deferredPrompt)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                        _createElementVNode("img", {
                          class: "rounded-lg",
                          src: $setup.designCustom.pwaLogo ? `${$setup.apiBaseUrl}/storage/${$setup.designCustom.pwaLogo}`:'/assets/favicon.png',
                          style: {"height":"5rem","width":"5rem"}
                        }, null, 8, _hoisted_89),
                        _createElementVNode("div", null, [
                          _hoisted_90,
                          _hoisted_91,
                          _createElementVNode("button", {
                            id: "install-pwa-btn",
                            class: "text-white rounded-3xl flex items-center gap-2 w-full px-8 py-3 mt-4 text-white rounded-xl font-medium transition duration-200 bg-primary justify-center",
                            onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => ($setup.installPWA && $setup.installPWA(...args)))
                          }, [
                            (_openBlock(), _createElementBlock("svg", _hoisted_92, _hoisted_94)),
                            _createTextVNode(" Instalar ")
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }, 8, ["isOpen", "toggleModal"]))
        : _createCommentVNode("", true),
      _createVNode(_component_AuthModal),
      _createVNode(_component_CartSidebar, {
        isOpen: $setup.isCartOpen,
        setIsOpen: (value) => $setup.isCartOpen = value,
        setIsAuthModalOpen: (value) => $setup.isAuthModalOpen = value
      }, null, 8, ["isOpen", "setIsOpen", "setIsAuthModalOpen"]),
      _createElementVNode("div", _hoisted_95, [
        _createElementVNode("ul", _hoisted_96, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: { name: 'home'},
              class: _normalizeClass(["flex flex-col items-center", { 'active-link': _ctx.$route.path === '/about' }])
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock("svg", _hoisted_97, [
                  _createElementVNode("path", {
                    stroke: "none",
                    d: "M17.3701 5.25366L12.0901 1.5595C10.6509 0.551164 8.44172 0.606164 7.05755 1.67866L2.46505 5.26283C1.54839 5.97783 0.824219 7.4445 0.824219 8.5995V14.9245C0.824219 17.262 2.72172 19.1687 5.05922 19.1687H14.9409C17.2784 19.1687 19.1759 17.2712 19.1759 14.9337V8.71866C19.1759 7.48116 18.3784 5.9595 17.3701 5.25366ZM10.6876 15.502C10.6876 15.8778 10.3759 16.1895 10.0001 16.1895C9.62422 16.1895 9.31255 15.8778 9.31255 15.502V12.752C9.31255 12.3762 9.62422 12.0645 10.0001 12.0645C10.3759 12.0645 10.6876 12.3762 10.6876 12.752V15.502Z",
                    class: _normalizeClass([ _ctx.$route.path === '/' ? 'fill-menu-hover' : 'fill-menu hover:fill-menu-hover' ])
                  }, null, 2)
                ])),
                _createElementVNode("p", {
                  class: _normalizeClass(["text-xs", _ctx.$route.path === '/' ? 'text-menu-hover' : 'text-menu hover:text-menu-hover'])
                }, "Home", 2)
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: { name: 'categories'},
              class: "flex flex-col items-center"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock("svg", _hoisted_98, [
                  _createElementVNode("path", {
                    d: "M4 8.78516H6C8 8.78516 9 7.78516 9 5.78516V3.78516C9 1.78516 8 0.785156 6 0.785156H4C2 0.785156 1 1.78516 1 3.78516V5.78516C1 7.78516 2 8.78516 4 8.78516ZM16 8.78516H18C20 8.78516 21 7.78516 21 5.78516V3.78516C21 1.78516 20 0.785156 18 0.785156H16C14 0.785156 13 1.78516 13 3.78516V5.78516C13 7.78516 14 8.78516 16 8.78516ZM16 20.7852H18C20 20.7852 21 19.7852 21 17.7852V15.7852C21 13.7852 20 12.7852 18 12.7852H16C14 12.7852 13 13.7852 13 15.7852V17.7852C13 19.7852 14 20.7852 16 20.7852ZM4 20.7852H6C8 20.7852 9 19.7852 9 17.7852V15.7852C9 13.7852 8 12.7852 6 12.7852H4C2 12.7852 1 13.7852 1 15.7852V17.7852C1 19.7852 2 20.7852 4 20.7852Z",
                    stroke: "#fff",
                    "stroke-width": "1.5",
                    "stroke-miterlimit": "10",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    fill: "#292f31",
                    class: _normalizeClass([ _ctx.$route.path.startsWith('/categor') ? 'fill-menu-hover' : 'fill-menu hover:fill-menu-hover' ])
                  }, null, 2)
                ])),
                _createElementVNode("p", {
                  class: _normalizeClass(["text-xs", _ctx.$route.path.startsWith('/categor') ? 'text-menu-hover' : 'text-menu hover:text-menu-hover'])
                }, "Categorias", 2)
              ]),
              _: 1
            })
          ]),
          ($setup.isWaiterEnabled)
            ? (_openBlock(), _createElementBlock("li", _hoisted_99, [
                _createElementVNode("button", {
                  onClick: _cache[21] || (_cache[21] = ($event: any) => ($setup.isQrcodeReaderOpen = true)),
                  class: _normalizeClass(["rounded-full flex items-center justify-center", $setup.tableNumber ? '':'w-12 h-12']),
                  style: _normalizeStyle({background: $setup.tableNumber ? 'transparent' : (!$setup.designCustom.primaryColor ? 'rgb(2 132 199/1)':$setup.designCustom.primaryColor)})
                }, [
                  (_openBlock(), _createElementBlock("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: $setup.tableNumber ? 22:22,
                    height: $setup.tableNumber ? 22:22,
                    class: _normalizeClass($setup.tableNumber ? 'fill-primary':'fill-white'),
                    viewBox: "0 0 16 16"
                  }, [
                    _hoisted_101,
                    _createTextVNode(),
                    _hoisted_102,
                    _createTextVNode(),
                    _hoisted_103,
                    _createTextVNode(),
                    _hoisted_104,
                    _createTextVNode(),
                    _hoisted_105
                  ], 10, _hoisted_100))
                ], 6),
                ($setup.tableNumber)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_106, "Mesa " + _toDisplayString($setup.tableNumber), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (!$setup.restaurant.restaurantConfig?.isDigitalCatalog)
            ? (_openBlock(), _createElementBlock("li", _hoisted_107, [
                _createVNode(_component_router_link, {
                  to: { name: 'orders'},
                  class: "flex flex-col items-center"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock("svg", _hoisted_108, [
                      _createElementVNode("path", {
                        fill: "none",
                        d: "M8 7H16M9 11H15M6.73 19.7C7.55 18.82 8.8 18.89 9.52 19.85L10.53 21.2C11.34 22.27 12.65 22.27 13.46 21.2L14.47 19.85C15.19 18.89 16.44 18.82 17.26 19.7C19.04 21.6 20.49 20.97 20.49 18.31V7.04C20.5 3.01 19.56 2 15.78 2H8.22C4.44 2 3.5 3.01 3.5 7.04V18.3C3.5 20.97 4.96 21.59 6.73 19.7Z",
                        "stroke-width": "1.5",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        stroke: "#292f31",
                        class: _normalizeClass([ _ctx.$route.path?.startsWith('/orders') ? 'stroke-menu-hover' : 'stroke-menu hover:stroke-menu-hover' ])
                      }, null, 2)
                    ])),
                    _createElementVNode("p", {
                      class: _normalizeClass(["text-xs", _ctx.$route.path?.startsWith('/orders') ? 'text-menu-hover' : 'text-menu hover:text-menu-hover'])
                    }, "Pedidos", 2)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (!$setup.restaurant.restaurantConfig?.isDigitalCatalog)
            ? (_openBlock(), _createElementBlock("li", _hoisted_109, [
                _createElementVNode("button", {
                  onClick: _cache[22] || (_cache[22] = ($event: any) => ($setup.isCartOpen = true)),
                  class: "flex flex-col gap-1 items-center relative"
                }, [
                  _createElementVNode("div", _hoisted_110, [
                    _hoisted_111,
                    ($setup.cart.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_112, _toDisplayString($setup.cart.length), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_113
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_MyModal, {
        id: 'info-modal',
        toggleModal: (value) => $setup.isInfoModalOpen = value,
        className: 'info',
        isOpen: $setup.isInfoModalOpen,
        zIndex: "150"
      }, {
        default: _withCtx(() => [
          _hoisted_114,
          _createElementVNode("div", _hoisted_115, [
            _createElementVNode("div", _hoisted_116, [
              _createElementVNode("button", {
                class: "transition duration-200 hover:text-primary",
                onClick: _cache[23] || (_cache[23] = ($event: any) => ($setup.isInfoModalOpen = false))
              }, [
                (_openBlock(), _createElementBlock("svg", _hoisted_117, _hoisted_119))
              ])
            ]),
            _createElementVNode("div", _hoisted_120, [
              _createElementVNode("button", {
                class: _normalizeClass([$setup.currentInfoSection == 'about' ? 'border-secondary':'', "col-span-4 pb-4 text-center border-b-2 transition-all duration-200 font-semibold"]),
                onClick: _cache[24] || (_cache[24] = ($event: any) => ($setup.currentInfoSection = 'about'))
              }, _hoisted_122, 2),
              _createElementVNode("button", {
                class: _normalizeClass([$setup.currentInfoSection == 'operating_hours' ? 'border-secondary':'', "col-span-4 pb-4 text-center border-b-2 transition-all duration-200 font-semibold"]),
                onClick: _cache[25] || (_cache[25] = ($event: any) => ($setup.currentInfoSection = 'operating_hours'))
              }, _hoisted_124, 2),
              _createElementVNode("button", {
                class: _normalizeClass([$setup.currentInfoSection == 'social_media' ? 'border-secondary':'', "col-span-4 border-b-2 pb-4 text-center transition-all duration-200 font-semibold"]),
                onClick: _cache[26] || (_cache[26] = ($event: any) => ($setup.currentInfoSection = 'social_media'))
              }, _hoisted_126, 2)
            ]),
            _createElementVNode("div", _hoisted_127, [
              ($setup.currentInfoSection == 'about')
                ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                    _createElementVNode("div", null, [
                      _hoisted_129,
                      _createElementVNode("p", _hoisted_130, _toDisplayString($setup.restaurant.aboutUs), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_131,
                      _createElementVNode("p", _hoisted_132, _toDisplayString($setup.restaurant.address), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              ($setup.currentInfoSection == 'operating_hours')
                ? (_openBlock(), _createElementBlock("div", _hoisted_133, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys($setup.days), (day, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "flex items-center justify-between pb-2",
                        key: index
                      }, [
                        _createElementVNode("p", {
                          class: _normalizeClass(["font-semibold text-sm", $setup.days[day] == $setup.today ? 'text-primary':''])
                        }, _toDisplayString($setup.days[day]), 3),
                        (_ctx.schedule = $setup.restaurant.restaurantConfig?.businessHours?.[$setup.dayKeyMap[day]])
                          ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                              (!_ctx.schedule.closed)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_135, _toDisplayString(_ctx.schedule.open) + " às " + _toDisplayString(_ctx.schedule.close), 1))
                                : (_openBlock(), _createElementBlock("p", _hoisted_136, " Fechado "))
                            ]))
                          : (_openBlock(), _createElementBlock("p", _hoisted_137, " Fechado "))
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              ($setup.currentInfoSection == 'social_media')
                ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                    _createElementVNode("div", _hoisted_139, [
                      ($setup.restaurant.restaurantConfig?.facebook)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            target: "_blank",
                            style: {"width":"50px","height":"50px"},
                            class: "flex items-center justify-center hover:scale-110 transform transition duration-200 border rounded-full",
                            href: $setup.restaurant.restaurantConfig?.facebook
                          }, _hoisted_142, 8, _hoisted_140))
                        : _createCommentVNode("", true),
                      ($setup.restaurant.restaurantConfig?.twitter)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            target: "_blank",
                            style: {"width":"50px","height":"50px"},
                            class: "flex items-center justify-center hover:scale-110 rounded-full transform transition duration-200 border",
                            href: $setup.restaurant.restaurantConfig?.twitter
                          }, _hoisted_145, 8, _hoisted_143))
                        : _createCommentVNode("", true),
                      ($setup.restaurant.restaurantConfig?.instagram)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 2,
                            target: "_blank",
                            style: {"width":"50px","height":"50px"},
                            class: "flex items-center justify-center hover:scale-110 transform transition duration-200 rounded-full border",
                            href: $setup.restaurant.restaurantConfig?.instagram
                          }, _hoisted_148, 8, _hoisted_146))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }, 8, ["toggleModal", "isOpen"]),
      _createVNode(_component_NotificationsModal),
      _createVNode(_component_MyModal, {
        id: 'qrcode-scanner-modal',
        isOpen: $setup.isQrcodeReaderOpen,
        toggleModal: (v) => $setup.isQrcodeReaderOpen = v,
        zIndex: "150"
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            onClick: _cache[27] || (_cache[27] = ($event: any) => ($setup.isQrcodeReaderOpen = false)),
            style: {"z-index":"200"},
            class: "transition duration-200 hover:text-primary absolute top-5 left-5"
          }, [
            (_openBlock(), _createElementBlock("svg", _hoisted_149, _hoisted_151))
          ]),
          _hoisted_152,
          ($setup.isQrcodeReaderOpen)
            ? (_openBlock(), _createBlock(_component_QrcodeStream, {
                key: 0,
                onDecode: $setup.onDecode,
                onDetect: $setup.onDecode
              }, {
                default: _withCtx(() => [
                  _hoisted_153
                ]),
                _: 1
              }, 8, ["onDecode", "onDetect"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["isOpen", "toggleModal"]),
      _createVNode(_component_CustomerRequestModal, {
        isCustomerRequestModal: $setup.isCustomerRequestModal,
        setIsCustomerRequestModal: (value) => $setup.isCustomerRequestModal = value
      }, null, 8, ["isCustomerRequestModal", "setIsCustomerRequestModal"]),
      ($setup.tableNumber && $setup.customer.is_registered)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: _cache[28] || (_cache[28] = ($event: any) => ($setup.isCustomerRequestModal = true)),
            style: {"background":"#292f31"},
            class: "fixed bottom-[13%] right-[5%] p-2 rounded-full z-20"
          }, [
            (_openBlock(), _createElementBlock("svg", _hoisted_154, _hoisted_156))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass([$setup.showNotification ? 'opacity-1':'opacity-0 hide-notification', "sm:w-96 font-inter transition-opacity duration-200 box-shadow fixed top-[5%] left-4 right-4 bg-white p-4 rounded-xl flex items-center gap-4"]),
        style: {"z-index":"370"}
      }, [
        _hoisted_157,
        _createElementVNode("div", null, [
          _createElementVNode("p", {
            class: _normalizeClass([$setup.notification.isError ? 'text-red-500':'text-success', "font-semibold"])
          }, _toDisplayString($setup.notification.title), 3),
          _createElementVNode("p", _hoisted_158, _toDisplayString($setup.notification.message), 1)
        ])
      ], 2),
      _createVNode(_component_MyModal, {
        id: 'install-pwa-modal',
        className: 'install-pwa',
        height: '17rem',
        width: '28rem',
        toggleModal: (value) => $setup.isInstallPwaModalOpen = value,
        isOpen: $setup.isInstallPwaModalOpen,
        zIndex: "150"
      }, {
        default: _withCtx(() => [
          _hoisted_159,
          _createElementVNode("div", _hoisted_160, [
            _createElementVNode("div", _hoisted_161, [
              _createElementVNode("h4", _hoisted_162, "Conheça o(a) " + _toDisplayString($setup.restaurant.name), 1),
              _createElementVNode("button", {
                class: "transition duration-200 hover:text-primary",
                onClick: _cache[29] || (_cache[29] = ($event: any) => {$setup.isInstallPwaModalOpen = false;})
              }, [
                (_openBlock(), _createElementBlock("svg", _hoisted_163, _hoisted_165))
              ])
            ]),
            _createElementVNode("div", _hoisted_166, [
              _createElementVNode("img", {
                class: "rounded-lg",
                src: $setup.designCustom.pwaLogo ? `${$setup.apiBaseUrl}/storage/${$setup.designCustom.pwaLogo}`:'/assets/favicon.png',
                style: {"height":"5rem","width":"5rem"}
              }, null, 8, _hoisted_167),
              _hoisted_168
            ]),
            _createElementVNode("div", _hoisted_169, [
              _createElementVNode("button", {
                id: "install-pwa-btn",
                class: "bg-secondary text-white rounded-3xl flex items-center gap-2",
                style: {"padding":"1rem 6rem"},
                onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => ($setup.installPWA && $setup.installPWA(...args)))
              }, [
                (_openBlock(), _createElementBlock("svg", _hoisted_170, _hoisted_172)),
                _createTextVNode(" Instalar ")
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["toggleModal", "isOpen"]),
      ($setup.isLoading)
        ? (_openBlock(), _createBlock(_component_CentralLoader, {
            key: 2,
            zIndex: 500
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_FooterComponent, { designCustom: $setup.designCustom }, null, 8, ["designCustom"]),
    _hoisted_173
  ], 2))
}